<template>
    <div>
        <h2>Meeting</h2>
    </div>
</template>
<script>
export default {

}
</script>
<style></style>